import React from 'react'
import { Month as LibMonth, MonthProps } from 'react-day-picker'
import { useTranslation } from 'react-i18next'

export const Month = (props: MonthProps) => {
  const { t } = useTranslation()

  return (
    <div className="month-container">
      <LibMonth {...props} />
      <div className="font-size-12 text-right">
        <span className="text-red-500">*</span>
        {t('reservation_confirm.modal_booking.holiday_caption')}
      </div>
    </div>
  )
}
